import BreadcrumbsBlock from "@/components/layout/breadcrumbs";
import Button from "@/components/button";
import { CalendarListBlock } from "@/components/blocks/calendar-list-block";
import DistrictsActivitiesBlock from "@/components/blocks/districts-activities-block";
import { FacebookPostBlock } from "@/components/blocks/facebook-block";
import { Footer } from "@/components/layout/footer";
import { Header } from "@/components/layout/header";
import { ImageBlock } from "@/components/blocks/image-block";
import { InstagramPostBlock } from "@/components/blocks/instagram-post-block";
import Link from "@/components/link";
import { NewsArticleCard } from "@/components/blocks/news-article-card";
import { RecentNewsBlock } from "@/components/blocks/recent-news-block";
import { SnapWidgetBlock } from "@/components/blocks/snap-widget-block";
import { SocialMediaLinkBlock } from "@/components/blocks/social-media-link-block";
import Styleguide from "@/components/layout/styleguide";
import { QuoteBlock } from "@/components/blocks/quote-block";
import { HeroBlock } from "@/components/blocks/hero-block";
import { NewsListBlock } from "@/components/blocks/news-list-block";
import ShortcutsBlock from "@/components/blocks/shortcuts-block";
import SubMenuBlock from "@/components/blocks/submenu-block";
import { TerminSearchBlock } from "@/components/blocks/termin-search-block";
import { TwitterBlock } from "@/components/blocks/twitter-block";
import { XHtml } from "@/components/xhtml";
import { TopicNewsListBlock } from "@/components/blocks/topic-news-list-block";
import { OrbitGallery } from "@/components/blocks/event-rotating-image-block";
import { AthleteSearchBlock } from "@/components/blocks/athlete-search-block";
import EventBreadcrumbsBlock from "@/components/layout/event-breadcrumbs";
import {CourseSearchBlock} from "@/components/blocks/course-search-block";
// ReactComponents.{componentName}
export default {
  OrbitGallery,
  BreadcrumbsBlock,
  Button,
  CalendarListBlock,
  CourseSearchBlock,
  DistrictsActivitiesBlock,
  FacebookPostBlock,
  EventBreadcrumbsBlock,
  Footer,
  Header,
  HeroBlock,
  ImageBlock,
  AthleteSearchBlock,
  InstagramPostBlock,
  Link,
  NewsArticleCard,
  NewsListBlock,
  QuoteBlock,
  RecentNewsBlock,
  ShortcutsBlock,
  SnapWidgetBlock,
  SocialMediaLinkBlock,
  Styleguide,
  SubMenuBlock,
  TerminSearchBlock,
  TopicNewsListBlock,
  TwitterBlock,
  XHtml,
};